import { useState } from "react";

import { Box, Carousel } from "@braintrust/braintrust-ui-components";
import ProjectItem from "@js/apps/freelancer/components/projects/project-item";
import { ProjectModalItem } from "@js/apps/freelancer/components/projects/project-modal-item";
import { ModalInstance } from "@js/components/modal";
import { ModalSlider } from "@js/components/modal-slider";
import type { WorkSampleItem } from "@js/types/freelancer";

type ProjectsCarouselProps = {
  items: WorkSampleItem[];
  navigationNextRef: HTMLButtonElement | null;
  navigationPrevRef: HTMLButtonElement | null;
  itemWidth?: string;
};

export const ProjectsCarousel = ({
  navigationNextRef,
  navigationPrevRef,
  items,
  itemWidth,
}: ProjectsCarouselProps) => {
  const openProjectModal = (index: number) => {
    return openModalWithWorkItem({ items, initialIndex: index });
  };

  return (
    <>
      <Carousel
        slides={items.map((item, itemIndex) => {
          return (
            <Box key={item.id} sx={{ mr: 4 }}>
              <ProjectItem
                item={item}
                index={itemIndex}
                openProjectModal={openProjectModal}
              />
            </Box>
          );
        })}
        slideProps={{
          style: { width: itemWidth },
          onTouchMove: (e) => {
            e.stopPropagation();
          },
        }}
        navigation={{
          nextEl: navigationNextRef,
          prevEl: navigationPrevRef,
        }}
        keyboard={true}
      />
    </>
  );
};

type ProjectsModalSliderProps = {
  initialIndex?: number;
  items: WorkSampleItem[];
};

const ProjectsModalSlider = ({
  initialIndex = 0,
  items,
}: ProjectsModalSliderProps) => {
  const [index, setIndex] = useState(initialIndex);

  return (
    <ModalSlider
      index={index}
      setIndex={setIndex}
      items={items.map((item, itemIndex) => (
        <ProjectModalItem
          key={item.id}
          item={item}
          index={itemIndex}
          lastIndex={items.length - 1}
          openDifferentProject={setIndex}
        />
      ))}
    />
  );
};

const openModalWithWorkItem = (arg: ProjectsModalSliderProps) => {
  ModalInstance.open({
    children: <ProjectsModalSlider {...arg} />,
    closeButton: true,
  });
};
